import { render, staticRenderFns } from "./Pjico.vue?vue&type=template&id=77b6e804"
import script from "./Pjico.vue?vue&type=script&lang=js"
export * from "./Pjico.vue?vue&type=script&lang=js"
import style0 from "./Pjico.vue?vue&type=style&index=0&id=77b6e804&prod&lang=scss"
import style1 from "./Pjico.vue?vue&type=style&index=1&id=77b6e804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports